import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import View from 'view/base';
import Template_Gallery from 'view/template_gallery/gallery';

var Survey_Selection = View.extend({
    views: {
        widget_gallery: {},
        survey_gallery: {},
    },

    events: {
        'click .btn-template'                   : 'onChoiceClick',
        'click .btn-start'                      : 'onStartClick',
        'click .template-choice-container'      : 'onChoiceClick',
        'mouseenter .template-choice-container' : 'onMouseEnterProjectType',
        'mouseleave .template-choice-container' : 'onMouseLeaveProjectType'
    },

    dom_handlers: {
        onChoiceClick: function(e) {
            // skip if triggered by click on btn-start
            if ($(e.target).hasClass('btn-start')) {
                return;
            }

            var project_type = $(e.currentTarget).data('val');

            // hide template-gallery-selection
            this.$el.find('.template-gallery-selection').hide();

            if (project_type === 'feedback') {
                this.$el.find('.survey-template-gallery').hide();
                this.$el.find('.widget-template-gallery').show();
            } else {
                this.$el.find('.survey-template-gallery').show();
                this.$el.find('.widget-template-gallery').hide();
            }

            this.trigger('nav', project_type);
        },

        onStartClick: function(e) {
            e.preventDefault();

            var project_type = $(e.currentTarget).data('val');
            var template_code;

            if (project_type === 'survey') {
                template_code = 'su000';
            } else {
                template_code = 'wt101';
            }

            // send default template code
            this.trigger('submit:success', template_code);
        },

        onMouseEnterProjectType: function(e) {
            this.$el.find('.template-choice-container').addClass('inactive');
            $(e.currentTarget).removeClass('inactive');
        },

        onMouseLeaveProjectType: function(e) {
            this.$el.find('.template-choice-container').removeClass('inactive');
        }
    },

    event_listeners: {
        onGoBack: function() {
            this.$el.find('.template-gallery-selection').show();
            this.$el.find('.survey-template-gallery').hide();
            this.$el.find('.widget-template-gallery').hide();

            this.trigger('nav');
        },

        onSubmit: function(template_code, template) {
            this.trigger('submit:success', template_code, template);
        }
    },

    initialize: function(options) {
        this.views.widget_gallery = new Template_Gallery({
            project_type: 'feedback',
            initial_template_code: '',
            show_loader_on_select: !!options.show_loader_on_select
        });

        this.views.survey_gallery = new Template_Gallery({
            project_type: 'survey',
            initial_template_code: '',
            show_loader_on_select: !!options.show_loader_on_select
        });

        this.listenTo(this.views.widget_gallery, 'submit:success', this.event_listeners.onSubmit.bind(this));
        this.listenTo(this.views.survey_gallery, 'submit:success', this.event_listeners.onSubmit.bind(this));

        this.listenTo(this.views.widget_gallery, 'back', this.event_listeners.onGoBack.bind(this));
        this.listenTo(this.views.survey_gallery, 'back', this.event_listeners.onGoBack.bind(this));
    },

    render: function() {
        var content =
        '<div class="template-gallery-selection">' +
            '<h1>What would you like to do with this project?</h1>' +
            '<div class="grid-6-6 grid-gap-80 grid-12-mobile grid-gap-36-mobile">' +
                '<div class="template-choice-container" data-val="feedback">' +
                    '<div>' +
                        '<div class="project-type" data-val="feedback"></div>' +
                        '<h3>Collect user feedback</h3>' +
                        '<p>Capture visual feedback, bugs and new ideas with the all-in-one widget</p>' +
                        '<button type="button" class="primary medium full btn-template" data-theme="feedback" data-val="feedback">Select template</button>' +
                        '<button type="button" class="tertiary medium full btn-template" data-theme="feedback" data-val="feedback">Select template</button>' +
                        '<a href="#" class="btn-start" data-val="feedback">Start from scratch</a>' +
                    '</div>' +
                '</div>' +
                '<div class="template-choice-container" data-val="survey">' +
                    '<div>' +
                        '<div class="project-type" data-val="survey"></div>' +
                        '<h3>Start a survey</h3>' +
                        '<p>Collect user insights with targeted surveys like CSAT, NPS and more</p>' +
                        '<button type="button" class="primary medium full btn-template" data-theme="survey" data-val="survey">Select template</button>' +
                        '<button type="button" class="tertiary medium full btn-template" data-theme="survey" data-val="survey">Select template</button>' +
                        '<a href="#" class="btn-start" name="btn-start" data-val="survey">Start from scratch</a>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>' +
        '<div class="widget-template-gallery template-gallery"></div>' +
        '<div class="survey-template-gallery template-gallery"></div>';

        this.$el.html(content);

        this.views.widget_gallery.render().$el.appendTo(this.$el.find('.widget-template-gallery'));
        this.views.survey_gallery.render().$el.appendTo(this.$el.find('.survey-template-gallery'));

        return this;
    }
});

export default Survey_Selection;
